export enum DaymadeDrawTypePlanSubcode {
  BASE = 'BASE',
  BOOST = 'BOOST',
}
